import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import config from '../../config/app';
import { api } from '../api';

const useBroadcastQuery = () => {
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage || config.defaultLanguage;

    return useQuery({
        queryKey: ['broadcast', lang],
        queryFn: (): Promise<string[]> => {
            return api.get(`broadcast?lang=${lang}`).json<string[]>();
        },
    });
};

export default useBroadcastQuery;
